const View = require('./StockState').default
const container = require('./container')

module.exports = container(View)
